export default __webpack_public_path__ + "static/badge-color-dark-95e3e66556a75b15f67d49702f54a8ce2e9562477bf0ec1e49249b49be876af5.png";